import { Component, Input } from "@angular/core";

type ScreenNames = 'dashboard' | 'actions';

@Component({
    selector: "pl-empty-list",
    templateUrl: "./empty-list.component.html",
    styleUrls: ["./empty-list.component.scss"],
    standalone: false
})
export class EmptyListComponent {  

  @Input() screenName: ScreenNames = 'dashboard';

  public labels: { [key in ScreenNames]: { title: string; subtitle: string } } = {
    'dashboard': {
      title: 'Nenhum usuário encontrado',
      subtitle: 'Por favor, verifique se o logon digitado está correto.'
    },
    'actions': {
      title: 'Nenhuma ação encontrada',
      subtitle: 'Tente fazer uma nova pesquisa ou remova os filtros aplicados.'
    }
  };

}
